import {useEffect} from 'react';
import useUnreadNotification from '@di-shared/features/diag/useUnreadNotification';

interface HomeSestExchangeHistoryProps {
  vin: string;
}

function SestExchangeHistoryManual({vin}: HomeSestExchangeHistoryProps) {
  const {checkUnreadUserNotifications} = useUnreadNotification(vin);
  useEffect(() => {
    checkUnreadUserNotifications();
  }, []);

  return null;
}

export default SestExchangeHistoryManual;
